<div class="genie-page">
  <div class="genie-page-header">
    <div class="header-left">
      <div class="backButton" (click)="builderService.navigateBack()">
        <img src="/assets/icons/arrow-left.svg" alt="Go back" />
      </div>
      <p class="genie-page-title">{{ 'Integrations' | translate }}</p>
      <p class="genie-page-subtitle">{{ 'Connect Stacks with external platforms to sync products, orders, analytics, and automation efficiently.' | translate }}</p>
    </div>
  </div>

  <div class="integrations-grid">
    <!-- Zoho Inventory Card -->
    <div class="integration-card">
      <div class="card-header">
        <img src="assets/images/integrations/zoho.svg" [alt]="'Zoho Inventory' | translate" class="integration-logo" />
        <span *ngIf="zohoService.zohoConnected" class="status-badge active">{{ 'Active' | translate }}</span>
      </div>
      <h3 class="integration-title">{{ 'Zoho Inventory' | translate }}</h3>
      <p class="integration-description">{{ 'Sync your products, stock, and orders with Zoho Inventory automatically.' | translate }}</p>
      <button *ngIf="zohoService.zohoConnected" class="manage-btn" (click)="openPanel('zoho')">
        <img src="assets/icons/settings.svg" alt="">
        {{ 'manage' | translate }}
      </button>
      <button *ngIf="!zohoService.zohoConnected" class="configure-btn" (click)="openPanel('zoho')">
        {{ 'configure' | translate }}
      </button>
    </div>
    <!-- WordPress WooCommerce Card -->
    <div class="integration-card">
      <div class="card-header">
        <img src="assets/images/integrations/woocommerce.svg" [alt]="'WordPress' | translate" class="integration-logo" />
        <span *ngIf="wordpressConnected" class="status-badge active">{{ 'Active' | translate }}</span>
      </div>
      <h3 class="integration-title">{{ 'Wordpress sync' | translate }}</h3>
      <p class="integration-description">{{ 'Sync your products, stock, and orders with WordPress WooCommerce automatically.' | translate }}</p>
      <button *ngIf="wordpressConnected" class="manage-btn" (click)="openPanel('wordpress')">
        <img src="assets/icons/settings.svg" alt="">
        {{ 'manage' | translate }}
      </button>
      <button *ngIf="!wordpressConnected" class="configure-btn" (click)="openPanel('wordpress')">
        {{ 'configure' | translate }}
      </button>
    </div>

    <!-- Odoo Card -->
    <div class="integration-card">
      <div class="card-header">
        <img src="assets/images/integrations/odoo.svg" [alt]="'Odoo' | translate" class="integration-logo" />
        <span *ngIf="odooService.odooConnected" class="status-badge active">{{ 'Active' | translate }}</span>
      </div>
      <h3 class="integration-title">{{ 'Odoo' | translate }}</h3>
      <p class="integration-description">{{ 'Sync your products, stock, and orders with Odoo automatically.' | translate }}</p>
      <button *ngIf="odooService.odooConnected" class="manage-btn" (click)="openPanel('odoo')">
        <img src="assets/icons/settings.svg" alt="">
        {{ 'manage' | translate }}
      </button>
      <button *ngIf="!odooService.odooConnected" class="configure-btn" (click)="openPanel('odoo')">
        {{ 'configure' | translate }}
      </button>
    </div>

    <!-- Shopify Card -->
    <div class="integration-card">
      <div class="card-header">
        <img src="assets/images/integrations/shopify.svg" [alt]="'Shopify' | translate" class="integration-logo" />
        <span *ngIf="shopifyService.shopifyConnected" class="status-badge active">{{ 'Active' | translate }}</span>
      </div>
      <h3 class="integration-title">{{ 'Shopify' | translate }}</h3>
      <p class="integration-description">{{ 'Sync your products, orders, and collections with Shopify automatically.' | translate }}</p>
      <button *ngIf="shopifyService.shopifyConnected" class="manage-btn" (click)="openPanel('shopify')">
        <img src="assets/icons/settings.svg" alt="">
        {{ 'manage' | translate }}
      </button>
      <button *ngIf="!shopifyService.shopifyConnected" class="configure-btn" (click)="openPanel('shopify')">
        {{ 'configure' | translate }}
      </button>
    </div>

  </div>

</div>

<!-- Side Panel Overlay -->
<div class="panel-overlay" *ngIf="activePanelType" (click)="closePanel()"></div>

<!-- Zoho Configuration Panel -->
<div class="config-panel" [class.open]="activePanelType === 'zoho'">
  <div class="panel-header">
    <div class="panel-title">
      <img src="assets/images/integrations/zoho.svg" [alt]="'Zoho Inventory' | translate" class="panel-logo" />
      <div>
        <h2>{{ 'Zoho Inventory' | translate }}</h2>
        <span class="panel-subtitle">{{ 'Configuration' | translate }}</span>
      </div>
    </div>
    <button class="close-btn" (click)="closePanel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="panel-content">
    <div *ngIf="zohoService.zohoConnected" class="status-message success">
      <mat-icon>check_circle</mat-icon>
      <div>
        <strong>{{ 'Integration active' | translate }}</strong>
        <p>{{ 'Your Zoho Inventory account is successfully linked. Data is syncing automatically' | translate }}</p>
      </div>
    </div>

    <form [formGroup]="integrationsForm" class="config-form">
      <div class="form-group">
        <label>{{ 'Organization ID' | translate }}</label>
        <div class="input-with-icon">
          <mat-icon>business</mat-icon>
          <input type="text" formControlName="zohoOrgId" [readonly]="zohoService.zohoConnected" [placeholder]="'Organization ID' | translate" />
        </div>
      </div>

      <div class="form-group">
        <label>{{ 'Client ID' | translate }}</label>
        <div class="input-with-icon">
          <mat-icon>vpn_key</mat-icon>
          <input type="text" formControlName="zohoClientId" [type]="showZohoClientId ? 'text' : 'password'" placeholder="*/*/*/*/*/*/*/*" />
          <mat-icon class="toggle-visibility" (click)="showZohoClientId = !showZohoClientId">
            {{ showZohoClientId ? 'visibility_off' : 'visibility' }}
          </mat-icon>
        </div>
      </div>

      <div class="form-group">
        <label>{{ 'Client secret key' | translate }}</label>
        <div class="input-with-icon">
          <mat-icon>lock</mat-icon>
          <input type="text" formControlName="zohoClientSecret" [type]="showZohoSecret ? 'text' : 'password'" placeholder="*/*/*/*/*/*/*/*" />
          <mat-icon class="toggle-visibility" (click)="showZohoSecret = !showZohoSecret">
            {{ showZohoSecret ? 'visibility_off' : 'visibility' }}
          </mat-icon>
        </div>
      </div>
    </form>
  </div>

  <div class="panel-footer">
    <button *ngIf="!zohoService.zohoConnected" class="sync-btn" (click)="connectToZoho()" [disabled]="!integrationsForm.value.zohoClientId || !integrationsForm.value.zohoClientSecret">
      {{ 'Connect & Sync' | translate }}
    </button>
    <button *ngIf="zohoService.zohoConnected" class="sync-btn" (click)="saveIntegrations()">
      {{ 'Sync Setting' | translate }}
    </button>
    <button *ngIf="zohoService.zohoConnected" class="disconnect-btn" (click)="disconnectZoho()">
      {{ 'Disconnect Integration' | translate }}
    </button>
  </div>
</div>

<!-- WordPress Configuration Panel -->
<div class="config-panel" [class.open]="activePanelType === 'wordpress'">
  <div class="panel-header">
    <div class="panel-title">
      <img src="assets/images/integrations/woocommerce.svg" [alt]="'WordPress' | translate" class="panel-logo" />
      <div>
        <h2>{{ 'WordPress WooCommerce' | translate }}</h2>
        <span class="panel-subtitle">{{ 'Configuration' | translate }}</span>
      </div>
    </div>
    <button class="close-btn" (click)="closePanel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="panel-content">
    <div *ngIf="wordpressConnected" class="status-message success">
      <mat-icon>check_circle</mat-icon>
      <div>
        <strong>{{ 'Integration active' | translate }}</strong>
        <p>{{ 'Your WordPress WooCommerce site is successfully linked. Data is syncing automatically' | translate }}</p>
      </div>
    </div>

    <form [formGroup]="wordpressForm" class="config-form">
      <div class="form-group">
        <label>{{ 'WordPress Website URL' | translate }}</label>
        <div class="input-with-icon">
          <mat-icon>language</mat-icon>
          <input type="text" formControlName="wordpress_site_url" placeholder="https://mywordpresssite.com" />
        </div>
      </div>

      <div class="form-group">
        <label>{{ 'Sync Token' | translate }}</label>
        <div class="input-with-icon">
          <mat-icon>vpn_key</mat-icon>
          <input type="text" [value]="builderService.getToken()" readonly />
          <mat-icon class="copy-icon" (click)="copyToken()">content_copy</mat-icon>
        </div>
        <p class="form-hint">{{ 'Use this token in your WordPress site to authenticate sync requests' | translate }}</p>
      </div>
    </form>
  </div>

  <div class="panel-footer">
    <button class="sync-btn" (click)="saveWordpressSettings()">
      {{ wordpressConnected ? 'Save Settings' : 'Connect' | translate }}
    </button>
    <button *ngIf="wordpressConnected" class="disconnect-btn" (click)="disconnectWordpress()">
      {{ 'Disconnect Integration' | translate }}
    </button>
  </div>
</div>

<!-- Shopify Configuration Panel -->
<div class="config-panel" [class.open]="activePanelType === 'shopify'">
  <div class="panel-header">
    <div class="panel-title">
      <img src="assets/images/integrations/shopify.svg" [alt]="'Shopify' | translate" class="panel-logo" />
      <div>
        <h2>{{ 'Shopify' | translate }}</h2>
        <span class="panel-subtitle">{{ 'Configuration' | translate }}</span>
      </div>
    </div>
    <button class="close-btn" (click)="closePanel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="panel-content">
    <div *ngIf="shopifyService.shopifyConnected" class="status-message success">
      <mat-icon>check_circle</mat-icon>
      <div>
        <strong>{{ 'Integration active' | translate }}</strong>
        <p>{{ 'Your Shopify store is successfully linked. Data is syncing automatically' | translate }}</p>
      </div>
    </div>

    <!-- How to get credentials -->
    <div *ngIf="!shopifyService.shopifyConnected" class="how-to-steps">
      <h4>{{ 'How to get your Client ID & Secret' | translate }}</h4>
      <ol>
        <li>{{ 'Go to your Shopify Admin → Settings → Apps → click "Build apps in Dev Dashboard"' | translate }}</li>
        <li>{{ 'Click "Create app", give it any name (e.g. Stacks)' | translate }}</li>
        <li>{{ 'Under App setup set:' | translate }}
          <ul>
            <li><strong>{{ 'App URL:' | translate }}</strong> https://builder.stacksmarket.co/</li>
            <li><strong>{{ 'Redirect URL:' | translate }}</strong> https://builder.stacksmarket.co/wp-json/v4/shopify-oauth-callback</li>
            <li>{{ 'Disable "Embed app in Shopify admin"' | translate }}</li>
          </ul>
        </li>
        <li>{{ 'Under API access, add all required product, order, customer and inventory scopes' | translate }}</li>
        <li>{{ 'Under Distribution → Custom distribution, enter your store domain and install the app' | translate }}</li>
        <li>{{ 'Copy the Client ID and Client Secret from the app settings and paste them below' | translate }}</li>
      </ol>
    </div>

    <form [formGroup]="shopifyForm" class="config-form">
      <div class="form-group">
        <label>{{ 'Store URL' | translate }}</label>
        <div class="input-with-icon">
          <mat-icon>store</mat-icon>
          <input type="text" formControlName="shopifyStoreUrl" placeholder="mystore.myshopify.com" />
        </div>
        <p class="form-hint">{{ 'Enter your Shopify store URL without https://' | translate }}</p>
      </div>

      <div class="form-group">
        <label>{{ 'Client ID' | translate }}</label>
        <div class="input-with-icon">
          <mat-icon>vpn_key</mat-icon>
          <input type="text" formControlName="shopifyClientId" placeholder="{{ 'Enter your Shopify Client ID' | translate }}" />
        </div>
      </div>

      <div class="form-group">
        <label>{{ 'Client Secret' | translate }}</label>
        <div class="input-with-icon">
          <mat-icon>lock</mat-icon>
          <input type="text" formControlName="shopifyClientSecret" [type]="showShopifySecret ? 'text' : 'password'" placeholder="*/*/*/*/*/*/*/*" />
          <mat-icon class="toggle-visibility" (click)="showShopifySecret = !showShopifySecret">
            {{ showShopifySecret ? 'visibility_off' : 'visibility' }}
          </mat-icon>
        </div>
      </div>
    </form>
  </div>

  <div class="panel-footer">
    <button *ngIf="!shopifyService.shopifyConnected" class="sync-btn" (click)="connectToShopify()">
      {{ 'Connect Manually' | translate }}
    </button>
    <button *ngIf="shopifyService.shopifyConnected" class="sync-btn" (click)="saveShopifySettings()">
      {{ 'Save Settings' | translate }}
    </button>
    <button *ngIf="shopifyService.shopifyConnected" class="disconnect-btn" (click)="disconnectShopify()">
      {{ 'Disconnect Integration' | translate }}
    </button>
  </div>
</div>

<!-- Odoo Configuration Panel -->
<div class="config-panel" [class.open]="activePanelType === 'odoo'">
  <div class="panel-header">
    <div class="panel-title">
      <img src="assets/images/integrations/odoo.svg" [alt]="'Odoo' | translate" class="panel-logo" />
      <div>
        <h2>{{ 'Odoo' | translate }}</h2>
        <span class="panel-subtitle">{{ 'Configuration' | translate }}</span>
      </div>
    </div>
    <button class="close-btn" (click)="closePanel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="panel-content">
    <div *ngIf="odooService.odooConnected" class="status-message success">
      <mat-icon>check_circle</mat-icon>
      <div>
        <strong>{{ 'Integration active' | translate }}</strong>
        <p>{{ 'Your Odoo account is successfully linked. Data is syncing automatically' | translate }}</p>
      </div>
    </div>

    <form [formGroup]="integrationsForm" class="config-form">
      <div class="form-group">
        <label>{{ 'Odoo URL' | translate }}</label>
        <div class="input-with-icon">
          <mat-icon>language</mat-icon>
          <input type="text" formControlName="odooUrl" placeholder="https://mycompany.odoo.com" />
        </div>
      </div>

      <div class="form-group">
        <label>{{ 'Database Name' | translate }}</label>
        <div class="input-with-icon">
          <mat-icon>storage</mat-icon>
          <input type="text" formControlName="odooDataBaseName" [placeholder]="'Enter Odoo DB Name' | translate" />
        </div>
      </div>

      <div class="form-group">
        <label>{{ 'Login Email' | translate }}</label>
        <div class="input-with-icon">
          <mat-icon>email</mat-icon>
          <input type="text" formControlName="odooLogin" [placeholder]="'admin@company.com' | translate" />
        </div>
      </div>

      <div class="form-group">
        <label>{{ 'API Key' | translate }}</label>
        <div class="input-with-icon">
          <mat-icon>vpn_key</mat-icon>
          <input type="text" formControlName="odooApiKey" [type]="showOdooApiKey ? 'text' : 'password'" placeholder="*/*/*/*/*/*/*/*" />
          <mat-icon class="toggle-visibility" (click)="showOdooApiKey = !showOdooApiKey">
            {{ showOdooApiKey ? 'visibility_off' : 'visibility' }}
          </mat-icon>
        </div>
      </div>

      <div class="form-group" *ngIf="integrationsForm.get('odooUserId')?.value">
        <label>{{ 'User ID' | translate }}</label>
        <div class="input-with-icon">
          <mat-icon>person</mat-icon>
          <input type="text" formControlName="odooUserId" readonly />
        </div>
      </div>
    </form>
  </div>

  <div class="panel-footer">
    <button *ngIf="!odooService.odooConnected" class="sync-btn" (click)="connectToOdoo()">
      {{ 'Connect to Odoo' | translate }}
    </button>
    <button *ngIf="odooService.odooConnected" class="sync-btn" (click)="saveIntegrations()">
      {{ 'Save Settings' | translate }}
    </button>
    <button *ngIf="odooService.odooConnected" class="disconnect-btn" (click)="disconnectOdoo()">
      {{ 'Disconnect Integration' | translate }}
    </button>
  </div>
</div>
